import React from 'react';
import { Container } from '@src/components/Container';
import { AddPremiumServiceButton } from '../AddPremiumServiceButton';
import { BANNER_CONTENT_ACTIVITY_PAGE } from '../content';
import './styles.scss';

export const BannerOnCreateOpeningPage = () => {
  return (
    <Container className="premium-service-banner-create-opening" type="info">
      <h1
        className="premium-service-banner-create-opening__title"
        dangerouslySetInnerHTML={{ __html: BANNER_CONTENT_ACTIVITY_PAGE.TITLE }}
      />
      <p
        className="premium-service-banner-create-opening__sub-title"
        dangerouslySetInnerHTML={{ __html: BANNER_CONTENT_ACTIVITY_PAGE.SUB_TITLE }}
      />
      <AddPremiumServiceButton className="premium-service-banner-create-opening__button" />
    </Container>
  );
};
